import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';
import { formatLocalDate } from '~shared/utils/date-time';

interface ReportingTransactionDetailsParams {
  format?: string;
  startDate: string | Date;
  endDate: string | Date;
}

export const reportingTransactionDetailsAPI = async (
  params: ReportingTransactionDetailsParams,
) => {
  // Create a new object with formatted dates
  const formattedParams = {
    format: params.format,
    startDate: formatDateParam(params.startDate),
    endDate: formatDateParam(params.endDate),
  };

  const response = await baseAPI.get<string>('reporting/transaction-report', {
    params: formattedParams,
    responseType: 'text',
  });
  return response.data;
};

// Helper function to safely format date parameters
export const formatDateParam = (value: string | Date): string => {
  if (value instanceof Date) {
    return formatLocalDate(value);
  }
  return value;
};

export const useReportingTransactionDetails = (
  params: ReportingTransactionDetailsParams,
) => {
  return useQuery({
    queryKey: [
      KEYS.TRANSACTION_DETAILS_REPORT,
      formatDateParam(params.startDate),
      formatDateParam(params.endDate),
      params.format,
    ],
    queryFn: () => reportingTransactionDetailsAPI(params),
    enabled: !!params.format && !!params.startDate && !!params.endDate,
  });
};
